import * as styles from "./SliderThumb.css";

import { clsx } from "clsx";
import { useEffect, useState } from "react";
import type { JSX } from "react";

import { Slider as BaseSlider } from "@base-ui/react/slider";

import type { SliderThumbProps } from "./Slider.types";
import { SliderThumbTooltip } from "./SliderThumbTooltip";

export function SliderThumb({
  className,
  children,
  index,
  tooltip = "never",
  onPointerDown,
  ...props
}: SliderThumbProps): JSX.Element {
  const [pressed, setPressed] = useState(false);

  useEffect(() => {
    if (!pressed) {
      return undefined;
    }

    const release = () => setPressed(false);

    window.addEventListener("pointerup", release);
    window.addEventListener("pointercancel", release);

    return () => {
      window.removeEventListener("pointerup", release);
      window.removeEventListener("pointercancel", release);
    };
  }, [pressed]);

  return (
    <BaseSlider.Thumb
      data-slot="slider-thumb"
      data-pressed={pressed || undefined}
      index={index}
      className={clsx(styles.thumb, className)}
      onPointerDown={(event) => {
        if (tooltip === "auto") {
          setPressed(true);
        }

        onPointerDown?.(event);
      }}
      {...props}
    >
      {children}
      {tooltip !== "never" && (
        <SliderThumbTooltip index={index ?? 0} visibility={tooltip} />
      )}
    </BaseSlider.Thumb>
  );
}
